import { InjectionToken } from '@angular/core';
export interface IndicatorLabelTranslations {
  ultimate: string;
  premium: string;
  standard: string;
}

export const indicatorLabelDefaultTranslations: IndicatorLabelTranslations = {
  ultimate: 'ultimate',
  premium: 'premium',
  standard: 'standard'
};

export const INDICATOR_LABEL_TRANSLATIONS = new InjectionToken<IndicatorLabelTranslations>(
  'INDICATOR_LABEL_TRANSLATIONS'
);
